 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		36: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		36: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~air-quality-graphs~air-quality-report-lift~climate-action-search~collection-vehicle-search~c~dff58943","1":"vendors~air-quality-graphs~crisis-block~event-lift~listing~measuring-station-map~open-data-search~op~8f93a322","2":"vendors~climate-action-search~collection-vehicle-search~collection-vehicles-block~open-data-search~o~fe6e0e5c","3":"vendors~climate-action-search~open-data-search-results~search~waste-search-result","4":"accordion","5":"air-quality-graphs","6":"air-quality-report-lift","7":"anchor-links-block","8":"campaign-header","9":"campaign-mobile-header","10":"climate-action-search","11":"collection-vehicle-map-search","12":"collection-vehicle-map-search-block","13":"collection-vehicle-search","14":"collection-vehicle-search-block","15":"collection-vehicles-block","16":"contact-block","17":"crisis-block","18":"event-lift","19":"gift-list-search-results","20":"hero-search","21":"infocard-list","22":"joining-payment-calculator","23":"joining-payment-summary","24":"link-to-top","25":"listing","26":"location-week-calendar","27":"measuring-station-map","28":"open-data-search","29":"open-data-search-hero","30":"open-data-search-results","31":"opendata-resources-accordion","32":"page-navigation-block","33":"related-lift","34":"related-pages","35":"rss-feed","37":"search","38":"single-gift-item","40":"vendors~air-quality-graphs","41":"vendors~collection-vehicle-map-search","42":"vertical-video-list","43":"video-list","44":"waste-search","45":"waste-search-result","46":"water-history-header","47":"water-history-mobile-header","48":"water-payment-calculator","49":"water-payment-summary","50":"water-supply-breaks-filter","51":"water-supply-report-lift"}[chunkId]||chunkId) + "." + {"0":"a3e0ef253572ee7b3a0c","1":"f283606cea3de6294299","2":"d437e11e129727675caa","3":"8e317eb015d8cdaadac0","4":"fd55845f97d926af4d24","5":"437a64e50b8206e1054c","6":"b41ea70a6108b590bc78","7":"37f88b02bc228d5e7f6f","8":"05e058393c02dc9f9835","9":"b05ac2e22ba33ea1bd49","10":"4d1bdb0d03b48b750812","11":"355995e3e6f2c11c84e4","12":"40bc3c5af54cf419b51c","13":"08320f6d421c6595999e","14":"88d723a7c15cecbf9cff","15":"e8aecab947ccf9f93256","16":"e2cb043b998493682400","17":"8bfb85e45310d323690e","18":"bc5973dcd40ff14f8971","19":"61966b61cb604d80c6a4","20":"949a5006ac70c2faa8ad","21":"9118af71bf02447faf53","22":"4ce72356047f20ec9318","23":"d9bdc995efbfb29f000c","24":"193976185df88d4823ed","25":"4dd6a845d8e5276d1d79","26":"45dbaa8b5b1e1818cad6","27":"abc1cdb4d8fb7e6a4477","28":"20ed61789bb70fbbd1d8","29":"6393fcdcd887a35029b9","30":"41c1f7296957e8efe0dc","31":"b9575981ec2b61a9879b","32":"f5e972aa52a10dcd7d55","33":"e72655e4493880bdc599","34":"13fe43884d7d1709fa78","35":"8cde42d7c6462970b6a0","37":"a67d8ebf0d6502be0b96","38":"dbcdba166f549188f7f1","40":"3eac0d20005e786acdb1","41":"7977326adfb876f87a1d","42":"9260bbc77c31b6be65e4","43":"f5c4f0aa2ef0526f21c0","44":"26dbb429b0fccbca6f29","45":"0d5b16fc9e4a659d3d1b","46":"e56154c66101dcf72836","47":"8ce4c7ab70cf7382e124","48":"94205032f3c570c389ea","49":"6011694636a656f1bfb2","50":"aa82b5dff61c2200fea1","51":"0293b9bc501e629d4e9a"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"11":1,"12":1,"46":1,"47":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "e6Wu");
